import { PHASE } from '../../domain/operations.js';
import { randomInteger } from './random.js';
import type { FlowFacts, FlowState } from './types.js';

/** Candidates come from the model's own admission clock and stream, never an L0 future trace. */
export function admitFlowPassenger(state: FlowState, facts: FlowFacts): void {
    if (state.dissatisfied > 0 && Math.floor(state.frame / 1800) > Math.floor((state.frame - 60) / 1800)) state.dissatisfied--;
    state.spawnClock += 60;
    if (state.spawnClock < (state.nextArrivalIn || facts.arrivalFrames)) return;
    const seats = state.planes.reduce((sum, p) => sum + (([PHASE.BOARDING, PHASE.READY] as number[]).includes(p.phase) ? Math.max(0, p.seats - p.boarded) + p.seats : p.seats), 0);
    // Every traveller counts, including one mid-question at the gate desk.
    const outgoing = state.lounge.length + state.inquiry.length + state.transit.length + state.reservations.length
        + state.departments.reduce((sum, d) => sum + d.queued.length + d.inService.length + d.completed.length, 0);
    const first = state.departments[0];
    if (!seats || outgoing >= seats || outgoing + state.inbound.length >= facts.maxPassengers
        || first.queued.length + first.inService.length + first.completed.length >= 12) return;
    state.spawnClock = 0;
    state.nextArrivalIn = Math.round(facts.arrivalFrames * (0.8 + randomInteger(state, 0, 60) / 100));
    const serial = ++state.serial;
    randomInteger(state, 0, 5); // The live admission also draws a tint, independently of its model use.
    state.transit.push({ destination: 0, remainingFrames: facts.entryFrames, serial, vip: serial % 9 === 0, massMilli: 1000, patienceFrames: facts.queuePatience, leavingFrames: 0 });
    state.admittedMilli += 1000;
}
